import styled from "@emotion/styled";
import { ApiRouteAttempt } from "griptonite-api-client";

const AttemptsInline = styled.div`
  display: flex;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-color: #ccc;
  border-style: solid;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
`;
const AttemptsInlineAttempt = styled.div<{
  success: boolean;
  zone: boolean;
  isSummary?: boolean;
}>`
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  font-size: 14px;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
  background-color: white;
  font-weight: bold;
  color: ${({ success, zone }) => (zone && !success ? "white" : "black")};
  ${({ success, zone }) =>
    success
      ? "background: #45D27E;"
      : zone
        ? "background: radial-gradient(100% 2434.05% at 2.19% 0%, #2C8DFF 0%, #0075FF 100%);"
        : ""}
  ${({ isSummary }) => (isSummary ? "width: 24px; color: #888" : "")}
`;

export const AttemptsPreview = ({
  attempts,
  climbType,
  segmentsCount,
}: {
  attempts: ApiRouteAttempt[];
  climbType: "BOULDER" | "SPORT";
  segmentsCount?: number | null;
}) => {
  if (climbType === "BOULDER") {
    return (
      <AttemptsInline>
        {[...Array(5)].map((_, i) => {
          let content, isSummary;
          if (attempts.length > 5) {
            if (
              attempts[attempts.length - 1]?.segmentsCount ||
              attempts[attempts.length - 1]?.success
            ) {
              isSummary = i === 3;
            } else {
              isSummary = i === 4;
            }
          }
          let attempt;
          if (attempts.length > 5 && i === 4) {
            attempt = attempts[attempts.length - 1];
          } else {
            attempt = attempts[i];
          }
          if (isSummary) {
            content = `+${attempts.length - 4}`;
          } else if (attempt?.success) {
            content = "T";
          } else if (attempt?.segmentsCount) {
            if (segmentsCount && segmentsCount > 1) {
              content = `Z${attempt.segmentsCount}`;
            } else {
              content = "Z";
            }
          } else if (attempt) {
            content = "-";
          }

          return (
            <AttemptsInlineAttempt
              key={i}
              success={!!attempt?.success}
              zone={!!attempt?.segmentsCount}
              isSummary={isSummary}
            >
              {content || ""}
            </AttemptsInlineAttempt>
          );
        })}
      </AttemptsInline>
    );
  } else {
    return (
      <strong>
        {attempts[0]?.success ? (
          "TOP"
        ) : (
          <>
            {attempts[0]?.segmentsCount}
            {attempts[0]?.usedLastHold ? "+" : ""}
          </>
        )}
      </strong>
    );
  }
};
